import { StaticLocationParamaters } from 'cg-foundation-theming';
var CompareListComponentController = (function () {
    function CompareListComponentController(compareChannel, $location, locationService) {
        this.compareChannel = compareChannel;
        this.$location = $location;
        this.locationService = locationService;
    }
    CompareListComponentController.prototype.$onInit = function () {
        var _this = this;
        this.groups = this.compareChannel.get();
        this.compareChannel
            .onAdd()
            .then(null, null, function () { _this.groups = _this.compareChannel.get(); });
        this.compareChannel
            .onRemove()
            .then(null, null, function () { _this.groups = _this.compareChannel.get(); });
        this.compareChannel
            .onReset()
            .then(null, null, function () { _this.groups.length = 0; });
    };
    CompareListComponentController.prototype.compare = function () {
        var thirdPartyProducts = this.locationService
            .get(StaticLocationParamaters.thirdPartyProducts, true);
        var products = this.groups.map(function (g) { return g.searchKey; });
        var search = this.$location.search();
        var filters = search.filters;
        var url = this.locationService.build('compatibilityguide/compare', { filters: filters, products: products, thirdPartyProducts: thirdPartyProducts });
        this.$location.url(url);
    };
    CompareListComponentController.prototype.remove = function (group) {
        this.compareChannel.remove(group);
    };
    CompareListComponentController.prototype.reset = function () {
        this.compareChannel.reset();
    };
    CompareListComponentController.$inject = [
        'compareChannel',
        '$location',
        'locationService',
    ];
    return CompareListComponentController;
}());
export var CompareListComponent = {
    controller: CompareListComponentController,
    templateUrl: 'compatibilityguide/ng-templates/feature/compare/comparelist',
};
